import CoreAPI from "../apis/gemmiciApiService/CoreAPI";
export default {
  getThemesByCategories() {
    return CoreAPI.retrieveThemesByCategoryAPI();
  }
};
